

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { withSnackbar } from '../../utils/SnackbarHOC';
import { Box, Chip, Typography } from '@mui/material';
import Loader from '../../components/Loader/Loader';
import { getCollaborateurById, updateCollaborateur, renewCollaborateurManually, addCollaborateurDocument, getCollaborateurDocuments, deleteCollaborateurDocument } from '../../services/CollaborateurService';
import Modal from '../../components/Modal/Modal';
import { AppButton } from '../../components/UI';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { getAllContrats } from '../../services/ContratService';
import { getDocumentContratGroupedByContrat } from '../../services/DocumentContratService';
import SaveBar from './components/SaveBar';
import RequiredDocsPanel from './components/RequiredDocsPanel';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import ViewSection from './components/ViewSection';
import ContractEndMessage from './components/ContractEndMessage';
import CollaborateurDocuments from './components/CollaborateurDocuments';
import CollaboratorDetailsCard from './components/CollaboratorDetailsCard';
import ContractDetailsCard from './components/ContractDetailsCard';
import AddContractDialog from './components/AddContractDialog';
import StageRenewOptionsDialog from './components/StageRenewOptionsDialog';
import ProlongStageFormDialog from './components/ProlongStageFormDialog';
import ProlongCdiFormDialog from './components/ProlongCdiFormDialog';
import CdiRenewOptionsDialog from './components/CdiRenewOptionsDialog';
import CdiRenewalSubOptionsDialog from './components/CdiRenewalSubOptionsDialog';
import ChangeContractTypeDialog from './components/ChangeContractTypeDialog';
import RenewOptionsDialog from './components/RenewOptionsDialog';
import ProlongFormDialog from './components/ProlongFormDialog';

// The API returns the contract as an object, the form works with its id.
const toContratId = (contrat) => (contrat && typeof contrat === 'object' ? contrat.id : contrat) || '';

const VisualiserCollaborateur = ({ snackbarShowMessage, setReloadNotifications, reloadNotifications }) => {
  const { id } = useParams();
  const [employee, setEmployee] = useState(null);
  const [originalEmployee, setOriginalEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [contratOptions, setContratOptions] = useState([]);
  const [openAddContrat, setOpenAddContrat] = useState(false);
  const [addContratOrigin, setAddContratOrigin] = useState(null);
  const [newContratName, setNewContratName] = useState('');
  const [showStageRenewDialog, setShowStageRenewDialog] = useState(false);
  const [showCdiRenewDialog, setShowCdiRenewDialog] = useState(false);
  const [showRenewOptionsDialog, setShowRenewOptionsDialog] = useState(false);
  const [showProlongerForm, setShowProlongerForm] = useState(false);

  const [showProlongerStageForm, setShowProlongerStageForm] = useState(false);
  const [prolongerPeriod, setProlongerPeriod] = useState('');
  const [showProlongCdiForm, setShowProlongCdiForm] = useState(false);


  const [uploadedFiles, setUploadedFiles] = useState({});

  const [prolongerDateDebut] = useState(new Date());

  const [showCdiSubOptionsDialog, setShowCdiSubOptionsDialog] = useState(false);
  const [showChangerContratDialog, setShowChangerContratDialog] = useState(false);
  const [newContratType, setNewContratType] = useState('');
  const [newDateFin, setNewDateFin] = useState(null);
  const [newPeriode, setNewPeriode] = useState('');

  const [documentsParContrat, setDocumentsParContrat] = useState({});
  const [savedDocs, setSavedDocs] = useState([]);
  const [docsRefreshKey, setDocsRefreshKey] = useState(0);
  const [docToDelete, setDocToDelete] = useState(null);
  const [deletingDoc, setDeletingDoc] = useState(false);

  const confirmDeleteDoc = async () => {
    if (!docToDelete) return;
    setDeletingDoc(true);
    try {
      await deleteCollaborateurDocument(docToDelete.id);
      snackbarShowMessage('Document supprimé.', 'success');
      setDocToDelete(null);
      setDocsRefreshKey((k) => k + 1);
    } catch (error) {
      snackbarShowMessage('Impossible de supprimer le document.', 'error');
    } finally {
      setDeletingDoc(false);
    }
  };

  useEffect(() => {
    getCollaborateurDocuments(id)
      .then((res) => setSavedDocs(Array.isArray(res.data?.data) ? res.data.data : []))
      .catch(() => setSavedDocs([]));
  }, [id, docsRefreshKey]);


  useEffect(() => {
    const fetchContrats = async () => {
      try {
        const { data } = await getAllContrats();
        setContratOptions(data);
      } catch {
        snackbarShowMessage('Erreur chargement contrats.', 'error');
      }
    };
    fetchContrats();
  }, [snackbarShowMessage]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getCollaborateurById(id);
        const employeeData = {
          ...data,
          contratId: toContratId(data.contrat),
          renouvellements: data.renouvellements ?? false
        };
        setEmployee(employeeData);
        setOriginalEmployee(employeeData);
      } catch {
        snackbarShowMessage('Erreur chargement collaborateur.', 'error');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, snackbarShowMessage]);

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const { data } = await getDocumentContratGroupedByContrat();
        setDocumentsParContrat(data);
      } catch {
        snackbarShowMessage('Erreur chargement documents requis.', 'error');
      }
    };
    fetchDocs();
  }, [snackbarShowMessage]);

  const handleChange = (field, value) => {
    setEmployee(prev => ({ ...prev, [field]: value }));
  };

  
  const handleFileUploadChange = (docType, files) => {
    setUploadedFiles(prevFiles => ({
      ...prevFiles,
      [docType]: files.length > 0 ? files[0] : null, 
    }));
  };


  const handleSave = async () => {
    try {
      setSaving(true);
      const updatedEmployee = {
        ...employee,
        renouvellements: !!employee.renouvellements
      };
      await updateCollaborateur(id, updatedEmployee);

      
      for (const docType in uploadedFiles) {
        const file = uploadedFiles[docType];
        if (file) {
          await addCollaborateurDocument(id, file, docType); 
        }
      }

      setOriginalEmployee(updatedEmployee);
      if (Object.values(uploadedFiles).some(Boolean)) {
        setUploadedFiles({});
        setDocsRefreshKey((k) => k + 1);
      }
      setReloadNotifications(!reloadNotifications)
      snackbarShowMessage('Collaborateur sauvegardé.', 'success');
    } catch (error) {
      snackbarShowMessage(`Erreur sauvegarde: ${error.message || 'Quelque chose s\'est mal passé.'}`, 'error');
    } finally {
      setSaving(false);
    }
  };
  useEffect(() => { }, [reloadNotifications])

  const isRecentIntegration = () => {
    if (!employee?.dateIntegration) return false;
    const d = new Date(employee.dateIntegration);
    const now = new Date();
    return ((now - d) / (1000 * 60 * 60 * 24 * 30)) <= 3;
  };

  const getDefaultDateFin = () => {
    if (!employee?.dateIntegration) return null;
    const d = new Date(employee.dateIntegration);
    d.setMonth(d.getMonth() + 3);
    return d;
  };

  const getDateFinFromPeriod = (start, period) => {
    const d = new Date(start);
    if (typeof period === 'string') {
      if (period.includes('mois')) {
        const months = parseInt(period);
        d.setMonth(d.getMonth() + months);
      } else if (period.includes('semaine')) {
        const weeks = parseInt(period);
        d.setDate(d.getDate() + weeks * 7);
      } else if (period.includes('an')) {
        const years = parseInt(period);
        d.setFullYear(d.getFullYear() + years);
      }
    }
    return d;
  };

  if (loading) return <Loader />;
  if (!employee) return <Box textAlign="center" mt={5}>Collaborateur introuvable.</Box>;


  const selectedContrat = contratOptions.find(c => c.id === employee.contratId);
  const contratNom = selectedContrat?.nom_contrat?.toLowerCase() || '';


  const selectedContratForMessage = contratOptions.find(c => c.id === originalEmployee.contratId);
  const contratNomForMessage = selectedContratForMessage?.nom_contrat?.toLowerCase() || '';


  const contractEndMessage = (() => {

    if (!originalEmployee.dateFinContrat) return null;

    const now = new Date();
    const end = new Date(originalEmployee.dateFinContrat);
    const diffDays = Math.ceil((end - now) / (1000 * 60 * 60 * 24));

    const currentContratType = originalEmployee.contrat?.nom_contrat?.toLowerCase() || '';

    if (currentContratType === 'cdi') {
      if (originalEmployee.nombreRenouvellements === 0) {
        if (diffDays >= 0 && diffDays <= 15) {
          return {
            text: diffDays === 0
              ? "Période de test se termine aujourd’hui."
              : `Période de test se termine dans ${diffDays} jour${diffDays > 1 ? 's' : ''}.`,
            color: '#f59e0b',
            backgroundColor: '#fef3c7',
            icon: <WarningAmberIcon />
          };
        }
      } else {
        if (diffDays >= 0 && diffDays <= 15) {
          return {
            text: diffDays === 0
              ? "Contrat CDI renouvelé se termine aujourd’hui."
              : `Contrat CDI renouvelé se termine dans ${diffDays} jour${diffDays > 1 ? 's' : ''}.`,
            color: '#b91c1c',
            backgroundColor: '#fee2e2',
            icon: <WarningAmberIcon />
          };
        }
      }
    } else if (diffDays >= 0 && diffDays <= 15) {
      return {
        text: diffDays === 0
          ? "Contrat se termine aujourd’hui."
          : `Contrat se termine dans ${diffDays} jour${diffDays > 1 ? 's' : ''}.`,
        color: '#b91c1c',
        backgroundColor: '#fee2e2',
        icon: <WarningAmberIcon />
      };
    } else if (end < now) {
      return {
        text: 'Le contrat est arrivé à son terme. Merci de procéder à une vérification.',
        color: '#b91c1c',
        backgroundColor: '#fee2e2',
        icon: <ErrorOutlineIcon />
      };
    }
    return null;
  })();

  const selectedNewContrat = contratOptions.find(c => c.id === newContratType)?.nom_contrat;

  const handleRenewClick = () => {
    if (contratNomForMessage === 'stage') {
      setShowStageRenewDialog(true);
    } else if (contratNomForMessage === 'cdi') {
      setShowCdiRenewDialog(true);
    } else {
      setShowRenewOptionsDialog(true);
    }
  };


  const handleAcceptCdi = async () => {
    setShowCdiSubOptionsDialog(false);
    setSaving(true);
    try {
      const dateDebut = new Date().toISOString().split('T')[0];

      await renewCollaborateurManually(id, {
        contratId: originalEmployee.contratId,
        dateDebut,
        dateFinContrat: null,
        periodeContrat: null,
      });

      const { data } = await getCollaborateurById(id);
      const updatedEmployeeData = {
        ...data,
        contratId: toContratId(data.contrat),
        renouvellements: data.renouvellements ?? false
      };

      setEmployee(updatedEmployeeData);
      setOriginalEmployee(updatedEmployeeData);

      snackbarShowMessage(<span><CheckCircleIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />Collaborateur accepté en CDI définitif </span>, 'success');
    } catch (error) {
      snackbarShowMessage(<span style={{ display: 'flex', alignItems: 'center' }}>
        <ErrorOutlineIcon style={{ color: '#d32f2f', marginRight: 6 }} />Erreur lors de l'acceptation du collaborateur en CDI: ${error.message} </span>, 'error');
    } finally {
      setSaving(false);
    }
  };


  const isMainFormDisabled = !!contractEndMessage;


  const requiredDocs = documentsParContrat[contratNom?.toUpperCase()] || [];
  const pendingUploads = Object.values(uploadedFiles).filter(Boolean).length;
  const fullName = [employee.prenom, employee.nom].filter(Boolean).join(' ') || 'Collaborateur';
  const initials = `${employee.prenom?.[0] || ''}${employee.nom?.[0] || ''}`.toUpperCase() || '?';
  const savedContratName = selectedContratForMessage?.nom_contrat || originalEmployee.contrat?.nom_contrat;
  const integrationDate = originalEmployee.dateIntegration
    ? new Date(originalEmployee.dateIntegration).toLocaleDateString('fr-FR')
    : null;
  const endDate = originalEmployee.dateFinContrat
    ? new Date(originalEmployee.dateFinContrat).toLocaleDateString('fr-FR')
    : null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%', minWidth: 0, overflowX: 'hidden', bgcolor: '#f5f7fa' }}>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
          px: { xs: 2, md: 3 },
          py: 1.5,
          bgcolor: '#fff',
          borderBottom: '1px solid #e2e8f0',
        }}
      >
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: '10px',
            bgcolor: '#ebf4fb',
            color: '#03407b',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: '0.9rem',
            flexShrink: 0,
          }}
        >
          {initials}
        </Box>
        <Box sx={{ flex: 1, minWidth: 200 }}>
          <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.25 }}>
            {employee.titre ? `${employee.titre} ` : ''}{fullName}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap', mt: 0.25 }}>
            {employee.fonction && (
              <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>{employee.fonction}</Typography>
            )}
            {savedContratName && (
              <Chip
                size="small"
                label={savedContratName.toUpperCase()}
                sx={{ height: 20, fontSize: '0.68rem', fontWeight: 700, bgcolor: '#ebf4fb', color: '#03407b' }}
              />
            )}
            {integrationDate && (
              <Chip
                size="small"
                icon={<EventOutlinedIcon />}
                label={`Intégré le ${integrationDate}`}
                sx={{ height: 20, fontSize: '0.68rem', bgcolor: '#f1f5f9', color: '#475569', '& .MuiChip-icon': { fontSize: 13 } }}
              />
            )}
            {endDate && (
              <Chip
                size="small"
                icon={<EventBusyOutlinedIcon />}
                label={`Fin le ${endDate}`}
                sx={{ height: 20, fontSize: '0.68rem', bgcolor: '#f1f5f9', color: '#475569', '& .MuiChip-icon': { fontSize: 13 } }}
              />
            )}
          </Box>
        </Box>
        <SaveBar handleSubmit={handleSave} loading={saving} disabled={isMainFormDisabled} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0, overflowY: 'auto', p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <ContractEndMessage contractEndMessage={contractEndMessage} handleRenewClick={handleRenewClick} />

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'repeat(2, minmax(0, 1fr))' }, gap: 2.5, alignItems: 'stretch' }}>
          <CollaboratorDetailsCard
            employee={employee}
            handleChange={handleChange}
            disabled={isMainFormDisabled}
          />
          <ContractDetailsCard
            employee={employee}
            handleChange={handleChange}
            contratOptions={contratOptions}
            setOpenAddContrat={setOpenAddContrat}
            setAddContratOrigin={setAddContratOrigin}
            contratNom={contratNom}
            isRecentIntegration={isRecentIntegration}
            getDefaultDateFin={getDefaultDateFin}
            contractEndMessage={contractEndMessage}
            disabled={isMainFormDisabled}
          />
        </Box>

        <ViewSection
          icon={<AttachFileIcon />}
          title="Pièces jointes"
          subtitle={
            contratNom
              ? `Checklist des documents du contrat ${contratNom.toUpperCase()} : déposez chaque fichier puis cliquez sur Sauvegarder.`
              : 'Choisissez un contrat pour afficher les documents à fournir.'
          }
          action={
            pendingUploads > 0 && (
              <Chip
                size="small"
                label={`${pendingUploads} fichier${pendingUploads > 1 ? 's' : ''} à enregistrer`}
                sx={{ fontWeight: 700, bgcolor: '#fffbeb', color: '#b45309', border: '1px solid #fcd34d' }}
              />
            )
          }
        >
          <RequiredDocsPanel
            requiredDocs={requiredDocs}
            uploadedFiles={uploadedFiles}
            onFileChange={handleFileUploadChange}
            onDeleteDoc={setDocToDelete}
            savedDocs={savedDocs}
            contratNom={contratNom}
            disabled={saving}
            snackbarShowMessage={snackbarShowMessage}
          >
            <CollaborateurDocuments collaborateurId={employee.id} snackbarShowMessage={snackbarShowMessage} refreshKey={docsRefreshKey} onDelete={setDocToDelete} />
          </RequiredDocsPanel>
        </ViewSection>

        <Modal
          open={!!docToDelete}
          onClose={() => !deletingDoc && setDocToDelete(null)}
          title="Supprimer le document ?"
          maxWidth="xs"
          actions={
            <>
              <AppButton variant="secondary" onClick={() => setDocToDelete(null)} disabled={deletingDoc}>
                Annuler
              </AppButton>
              <AppButton variant="danger" startIcon={<DeleteOutlinedIcon />} loading={deletingDoc} onClick={confirmDeleteDoc}>
                Supprimer
              </AppButton>
            </>
          }
        >
          <Typography sx={{ fontSize: '0.88rem', color: '#334155' }}>
            <strong>{docToDelete?.category}</strong> ({docToDelete?.fileName}) sera supprimé définitivement de la fiche du collaborateur.
          </Typography>
        </Modal>
      </Box>

      <AddContractDialog
        open={openAddContrat}
        onClose={() => {
          setOpenAddContrat(false);
          setAddContratOrigin(null);
          setNewContratName('');
        }}
        newContratName={newContratName}
        setNewContratName={setNewContratName}
        setContratOptions={setContratOptions}
        snackbarShowMessage={snackbarShowMessage}
        addContratOrigin={addContratOrigin}
        handleChange={handleChange}
        setNewContratType={setNewContratType}
        setNewPeriode={setNewPeriode}
        setNewDateFin={setNewDateFin}
        getDateFinFromPeriod={getDateFinFromPeriod}
        disabled={isMainFormDisabled}
      />


      <RenewOptionsDialog
        open={showRenewOptionsDialog}
        onClose={() => setShowRenewOptionsDialog(false)}
        onProlong={() => {
          setShowRenewOptionsDialog(false);
          setShowProlongerForm(true);
        }}
        onChangeContract={() => {
          setShowRenewOptionsDialog(false);
          setShowChangerContratDialog(true);
          setNewContratType('');
          setNewPeriode('');
          setNewDateFin(null);
        }}
      />

      <ProlongFormDialog
        open={showProlongerForm}
        onClose={() => setShowProlongerForm(false)}
        employeeId={id}
        employeeContratId={originalEmployee.contratId}
        snackbarShowMessage={snackbarShowMessage}
        setEmployee={setEmployee}
        currentDateFinContrat={originalEmployee.dateFinContrat}
        onBack={() => {
          setShowProlongerForm(false);
          setShowRenewOptionsDialog(true);
        }}
        setReloadNotifications={setReloadNotifications}
        reloadNotifications={reloadNotifications}
      />


      <StageRenewOptionsDialog
        open={showStageRenewDialog}
        onClose={() => setShowStageRenewDialog(false)}
        onProlongStage={() => {
          setShowStageRenewDialog(false);
          setShowProlongerStageForm(true);
          setProlongerPeriod('1mois');
        }}
        onChangeContract={() => {
          setShowStageRenewDialog(false);
          setShowChangerContratDialog(true);
          setNewContratType('');
          setNewPeriode('');
          setNewDateFin(null);
        }}
      />
      <CdiRenewOptionsDialog
        open={showCdiRenewDialog}
        onClose={() => setShowCdiRenewDialog(false)}
        onRenewCdi={() => {
          setShowCdiRenewDialog(false);
          setShowCdiSubOptionsDialog(true);
        }}
        onChangeContract={() => {
          setShowCdiRenewDialog(false);
          setShowChangerContratDialog(true);
          setNewContratType('');
          setNewPeriode('');
          setNewDateFin(null);
        }}

      />

      <CdiRenewalSubOptionsDialog
        open={showCdiSubOptionsDialog}
        onClose={() => setShowCdiSubOptionsDialog(false)}
        onBackToMainCdiOptions={() => {
          setShowCdiSubOptionsDialog(false);
          setShowCdiRenewDialog(true);
        }}
        onProlongTestPeriod={() => {
          setShowCdiSubOptionsDialog(false);
          setShowProlongCdiForm(true);
        }}
        onAcceptCollaborateur={handleAcceptCdi}

      />

      <ProlongCdiFormDialog
        open={showProlongCdiForm}
        onClose={() => setShowProlongCdiForm(false)}
        employeeId={id}
        employeeContratId={originalEmployee.contratId}
        snackbarShowMessage={snackbarShowMessage}
        setEmployee={setEmployee}
        currentDateFinContrat={originalEmployee.dateFinContrat}
        onBack={() => {
          setShowProlongCdiForm(false);
          setShowCdiSubOptionsDialog(true);
        }}
        setReloadNotifications={setReloadNotifications}
        reloadNotifications={reloadNotifications}
      />

      <ProlongStageFormDialog
        open={showProlongerStageForm}
        onClose={() => setShowProlongerStageForm(false)}
        prolongerPeriod={prolongerPeriod}
        setProlongerPeriod={setProlongerPeriod}
        prolongerDateDebut={prolongerDateDebut}
        getDateFinFromPeriod={getDateFinFromPeriod}
        employeeId={id}
        employeeContratId={originalEmployee.contratId}
        snackbarShowMessage={snackbarShowMessage}
        setEmployee={setEmployee}
        onBack={() => {
          setShowProlongerStageForm(false);
          setShowStageRenewDialog(true);
        }}
        setReloadNotifications={setReloadNotifications}
        reloadNotifications={reloadNotifications}
      />

      <ChangeContractTypeDialog
        open={showChangerContratDialog}
        onClose={() => setShowChangerContratDialog(false)}
        newContratType={newContratType}
        setNewContratType={setNewContratType}
        contratOptions={contratOptions}
        setAddContratOrigin={setAddContratOrigin}
        setOpenAddContrat={setOpenAddContrat}
        selectedNewContrat={selectedNewContrat}
        newPeriode={newPeriode}
        setNewPeriode={setNewPeriode}
        newDateFin={newDateFin}
        setNewDateFin={setNewDateFin}
        getDateFinFromPeriod={getDateFinFromPeriod}
        employeeId={id}
        snackbarShowMessage={snackbarShowMessage}
        setEmployee={setEmployee}
        setReloadNotifications={setReloadNotifications}
        reloadNotifications={reloadNotifications}

      />
    </Box>
  );
};

export default withSnackbar(VisualiserCollaborateur);